import { render, staticRenderFns } from "./LiteratureSection.vue?vue&type=template&id=955ea4d4&scoped=true&"
import script from "./LiteratureSection.vue?vue&type=script&lang=js&"
export * from "./LiteratureSection.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureSection.vue?vue&type=style&index=0&id=955ea4d4&lang=scss&scoped=true&"
import style1 from "./LiteratureSection.vue?vue&type=style&index=1&id=955ea4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955ea4d4",
  null
  
)

export default component.exports